export default "__VITE_PUBLIC_ASSET__f87f56a6__"